var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"class-name":"scrollable vertical-center-modal","width":"90%","footer-hide":true,"scrollable":true},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('iframe',{staticStyle:{"width":"100%","height":"95vh"},attrs:{"type":"application/pdf","id":"pdf-preview"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }